import React, { ReactNode } from 'react';

import './results__table-row.scss';

interface TableRowProps {
    children: ReactNode;
}

const TableRow = ({ children }: TableRowProps) => {
    return <div className="results__table-row">{children}</div>;
};

export default TableRow;
